"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var TriangleIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 6 9", fill: "currentColor", width: size || '6', height: size || '9' }, props),
        React.createElement("path", { fill: "currentColor", d: "M6 4.5L0 9V0z", fillRule: "evenodd" })));
};
TriangleIcon.displayName = 'TriangleIcon';
exports.default = TriangleIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TriangleIcon.js.map